import { Map as IMap, fromJS } from 'immutable';


export const REQUEST_ME = '@@storefront/auth/REQUEST_ME';
export const RECHECK_SESSION = '@@storefront/auth/RECHECK_SESSION';
export const SET_IDENTITY = '@@storefront/auth/SET_IDENTITY';
export const SET_UNAUTHENTICATED = '@@storefront/auth/SET_UNAUTHENTICATED';
export const ME_FETCH_FAILED = '@@storefront/auth/ME_FETCH_FAILED';
export const SESSION_EXPIRED = '@@storefront/auth/SESSION_EXPIRED';
export const DISMISS_SESSION_EXPIRED = '@@storefront/auth/DISMISS_SESSION_EXPIRED';

const initialState = IMap({
    status: 'idle', identity: null, ssoSid: null, sessionExpired: false
});




const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_ME:
            return state.set('status', 'loading');
        case SET_IDENTITY:
            
            
            return state.merge({
                status: 'authenticated',
                identity: fromJS(action.identity || {}),
                ssoSid: action.sid || null,
                sessionExpired: false
            });
        case SET_UNAUTHENTICATED:
        case ME_FETCH_FAILED:
            return state.merge({ status: 'unauthenticated', identity: null, ssoSid: null });
        case SESSION_EXPIRED:
            
            
            return state.merge({
                status: 'unauthenticated',
                identity: null,
                ssoSid: null,
                sessionExpired: true
            });
        case DISMISS_SESSION_EXPIRED:
            return state.set('sessionExpired', false);
        default:
            return state;
    }
};


export const requestMe = () => ({ type: REQUEST_ME });
export const recheckSession = () => ({ type: RECHECK_SESSION });
export const setIdentity = (identity, sid = null) => ({ type: SET_IDENTITY, identity, sid });
export const setUnauthenticated = () => ({ type: SET_UNAUTHENTICATED });
export const meFetchFailed = () => ({ type: ME_FETCH_FAILED });
export const sessionExpired = () => ({ type: SESSION_EXPIRED });
export const dismissSessionExpired = () => ({ type: DISMISS_SESSION_EXPIRED });

export default authReducer;
